<template>
    <svg
        width="170"
        height="34"
        viewBox="0 0 170 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_641_7012)">
            <path
                d="M28.1481 0.987305H23.4785V5.65693H28.1481V0.987305Z"
                fill="#040F0F"
            />
            <path
                d="M4.89904 0H0V33.2885H19.6746V28.7118H4.89904V0Z"
                fill="#040F0F"
            />
            <path
                d="M28.1481 8.79883H23.4785V33.2882H28.1481V8.79883Z"
                fill="#040F0F"
            />
            <path
                d="M45.633 8.52048C41.8665 8.52048 39.5317 9.97248 38.1349 11.4332L37.7138 8.79927H33.6191V33.2887H38.2888V21.0425C38.2888 15.9228 40.792 12.8649 44.9854 12.8649C49.9077 12.8649 50.9415 16.7068 50.9415 19.9303V33.2858H55.6111V19.698C55.6111 9.96958 49.3617 8.51758 45.6359 8.51758L45.633 8.52048Z"
                fill="#040F0F"
            />
            <path
                d="M89.06 6.59498V8.79911H84.7998V13.1435H89.06V33.2885H93.7296V13.1435H100.397V8.79911H93.7296V6.50205C93.7296 4.89033 94.2755 4.34438 95.8873 4.34438H100.397V0H95.6549C91.1567 0 89.06 2.09669 89.06 6.59498Z"
                fill="#040F0F"
            />
            <path
                d="M113.669 8.52051C106.513 8.52051 101.516 13.6693 101.516 21.0425C101.516 28.4158 106.513 33.5646 113.669 33.5646C120.824 33.5646 125.822 28.4158 125.822 21.0425C125.822 13.6693 120.824 8.52051 113.669 8.52051ZM113.669 29.3131C109.319 29.3131 106.278 25.9125 106.278 21.0425C106.278 16.1725 109.319 12.772 113.669 12.772C118.019 12.772 121.06 16.1725 121.06 21.0425C121.06 25.9125 118.019 29.3131 113.669 29.3131Z"
                fill="#040F0F"
            />
            <path
                d="M146.991 21.0421C146.991 26.1618 144.575 29.2197 140.527 29.2197C135.797 29.2197 134.803 25.3777 134.803 22.1543V8.79883H130.134V22.3866C130.134 32.115 136.238 33.567 139.877 33.567C142.877 33.567 145.316 32.6 147.143 30.6921L147.564 33.2882H151.658V8.79883H146.989V21.0421H146.991Z"
                fill="#040F0F"
            />
            <path
                d="M168.499 8.79883C164.709 8.79883 162.801 10.1724 161.643 11.6389L161.236 8.79883H157.136V33.2882H161.805V20.8127C161.805 18.0364 162.566 13.3755 167.669 13.3755H170.003V8.79883H168.502H168.499Z"
                fill="#040F0F"
            />
            <path
                d="M4.89904 0H0V33.2885H19.6746V28.7118H4.89904V0Z"
                fill="#040F0F"
            />
            <path
                d="M28.1481 8.79883H23.4785V33.2882H28.1481V8.79883Z"
                fill="#040F0F"
            />
            <path
                d="M45.633 8.52048C41.8665 8.52048 39.5317 9.97248 38.1349 11.4332L37.7138 8.79927H33.6191V33.2887H38.2888V21.0425C38.2888 15.9228 40.792 12.8649 44.9854 12.8649C49.9077 12.8649 50.9415 16.7068 50.9415 19.9303V33.2858H55.6111V19.698C55.6111 9.96958 49.3617 8.51758 45.6359 8.51758L45.633 8.52048Z"
                fill="#040F0F"
            />
            <path
                d="M89.06 6.59498V8.79911H84.7998V13.1435H89.06V33.2885H93.7296V13.1435H100.397V8.79911H93.7296V6.50205C93.7296 4.89033 94.2755 4.34438 95.8873 4.34438H100.397V0H95.6549C91.1567 0 89.06 2.09669 89.06 6.59498Z"
                fill="#040F0F"
            />
            <path
                d="M113.669 8.52051C106.513 8.52051 101.516 13.6693 101.516 21.0425C101.516 28.4158 106.513 33.5646 113.669 33.5646C120.824 33.5646 125.822 28.4158 125.822 21.0425C125.822 13.6693 120.824 8.52051 113.669 8.52051ZM113.669 29.3131C109.319 29.3131 106.278 25.9125 106.278 21.0425C106.278 16.1725 109.319 12.772 113.669 12.772C118.019 12.772 121.06 16.1725 121.06 21.0425C121.06 25.9125 118.019 29.3131 113.669 29.3131Z"
                fill="#040F0F"
            />
            <path
                d="M146.991 21.0421C146.991 26.1618 144.575 29.2197 140.527 29.2197C135.797 29.2197 134.803 25.3777 134.803 22.1543V8.79883H130.134V22.3866C130.134 32.115 136.238 33.567 139.877 33.567C142.877 33.567 145.316 32.6 147.143 30.6921L147.564 33.2882H151.658V8.79883H146.989V21.0421H146.991Z"
                fill="#040F0F"
            />
            <path
                d="M168.499 8.79883C164.709 8.79883 162.801 10.1724 161.643 11.6389L161.236 8.79883H157.136V33.2882H161.805V20.8127C161.805 18.0364 162.566 13.3755 167.669 13.3755H170.003V8.79883H168.502H168.499Z"
                fill="#040F0F"
            />
            <path
                d="M79.2381 33.5961L73.4243 28.0727C71.6442 26.2925 68.746 26.2925 66.9658 28.0727L66.9252 28.1133L61.3553 33.3928L58.3584 30.2304L63.9079 24.9683C67.3811 21.5184 73.0091 21.5184 76.4822 24.9683L82.238 30.4336L79.2381 33.5932V33.5961Z"
                fill="#040F0F"
            />
            <path
                d="M70.3983 19.3929C68.0258 19.3929 65.7926 18.4724 64.1112 16.7997L58.3555 11.3344L61.3553 8.1748L67.1691 13.6982C68.0316 14.5607 69.1787 15.037 70.3983 15.037C71.618 15.037 72.7651 14.5607 73.6276 13.6982L73.6682 13.6576L79.2381 8.37808L82.235 11.5405L76.6855 16.7997C75.0041 18.4724 72.7709 19.39 70.3983 19.39V19.3929Z"
                fill="#040F0F"
            />
        </g>
        <defs>
            <clipPath id="clip0_641_7012">
                <rect
                    width="170"
                    height="33.5963"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
</template>
